<template>
    <div>
      <TaxListAddNew :status.sync="isAddNewTaxSidebarActive" @refetch-data="refetchData" />
      <BCard no-body class="mb-0">
        <!-- Filters -->
        <div class="m-2">
          <BRow>
            <!-- Per Page -->
            <BCol cols="12" md="6" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
              <label>{{ $t('Show') }}</label>
              <vSelect v-model="perPage" :options="perPageOptions" :clearable="false" class="per-page-selector d-inline-block mx-50" />
              <label>{{$t('entries')}}</label>
            </BCol>
  
            <!-- Search -->
            <BCol cols="12" md="6">
              <div class="d-flex align-items-center justify-content-between">
                <BFormInput v-model="searchQuery" class="d-inline-block mr-1" :placeholder="$t('Search') + '...'"  />
                <BButton variant="primary" @click="addTax" v-if="ability.can('create', 'tax')">
                <!-- <BButton variant="primary" :to="{ name: 'taxes-add' }" v-if="ability.can('create', 'tax')"> -->
                  <span class="text-nowrap">{{$t('Add tax')}}</span>
                </BButton>
              </div>
            </BCol>
          </BRow>
        </div>
  
        <!-- Table -->
        <BTable ref="refTaxListTable" class="position-relative" :items="fetchTax" responsive :fields="tableColumns" primary-key="id" :sort-by.sync="sortBy" show-empty :empty-text="$t('No match records found')" :sort-desc.sync="isSortDirDesc">
      
            <template #cell(name)="data">
                 {{ data.item.name }}
            </template>

          <template #cell(value)="data">
            {{ data.item.value + " %" }}
          </template>

          <template #cell(equivalence)="data">
            {{ data.item.equivalence + " %" }}
          </template>
  
          <template #cell(actions)="data">
            <BDropdown variant="link" no-caret :right="$store.state.appConfig.isRTL">
  
              <template #button-content>
                <feather-icon icon="MoreVerticalIcon" size="16" class="align-middle text-body" />
              </template>
              <!-- <BDropdownItem :to="{ name: 'taxes-view', params: { id: data.item.id } }" v-if="ability.can('read', 'tax')">
                <feather-icon icon="FileTextIcon" />
                <span class="align-middle ml-50">{{$t('Details')}}</span>
              </BDropdownItem> -->
  
              <BDropdownItem @click="deletePopup(data.item.id, 'taxes/deleteTax')" v-if="ability.can('delete', 'tax')">
                <feather-icon icon="TrashIcon" />
                <span class="align-middle ml-50">{{$t('Delete')}}</span>
              </BDropdownItem>

              <BDropdownItem @click="fetchTaxToEdit(data.item.id)"  v-if="ability.can('write', 'tax')">
                <feather-icon icon="EditIcon" />
                <span  class="align-middle ml-50">{{$t('Edit')}}</span>
              </BDropdownItem>
            </BDropdown>
          </template>
        </BTable>
  
        <!-- Paginate -->
        <div class="mx-2 mb-2">
          <BRow>
            <BCol cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start">
              <span class="text-muted">{{$t('Showing')}} {{dataMeta.from}} {{$t('to')}} {{dataMeta.to}} {{$t('of')}} {{dataMeta.of}} {{$t('entries')}}</span>
            </BCol>
            <BCol cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">
              <BPagination v-model="currentPage" :total-rows="totalTax" :per-page="perPage" first-number last-number class="mb-0 mt-1 mt-sm-0" prev-class="prev-item" next-class="next-item">
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </BPagination>
            </BCol>
          </BRow>
        </div>
  
      </BCard>
    </div>
  </template>
  
<script>
import { BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink, BBadge, BDropdown, BDropdownItem, BPagination,} from 'bootstrap-vue'
import { onUnmounted, ref, provide, watch } from '@vue/composition-api'
import TaxListAddNew from './TaxListAddNew.vue'
import taxListQuery from './taxListQuery'
import ability from '@/libs/acl/ability'
import taxModule from '../taxModule'
import popups from '@/hooks/popups'
import vSelect  from 'vue-select'
import store from '@/store'
import axios from '@axios'


export default {
    components: { BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink, BBadge, BDropdown, BDropdownItem, BPagination, vSelect, TaxListAddNew },
    setup(){
        const { fetchTax, tableColumns, perPage, currentPage, totalTax, dataMeta, perPageOptions, searchQuery, sortBy, isSortDirDesc, refTaxListTable, refetchData } = taxListQuery()
        const { deletePopup } = popups()
        const isAddNewTaxSidebarActive = ref(false)
        const TAX_MODULE = 'taxes'
        const taxToEdit=ref(null)
        provide('taxToEdit', taxToEdit)

        const fetchTaxToEdit = (id) => {
          axios.get(`taxes/${id}`).then((response)=> {
            isAddNewTaxSidebarActive.value=true
            taxToEdit.value=response.data.tax
            taxToEdit.value.value=parseFloat(response.data.tax.value)
            taxToEdit.value.equivalence=parseFloat(response.data.tax.equivalence)
          })
        }

        const addTax = () => {
            isAddNewTaxSidebarActive.value=true
            taxToEdit.value={
                id:null,
                name: '',
                value: '',
                equivalence: ''
            }
        }
        watch(isAddNewTaxSidebarActive, () => {
          if (isAddNewTaxSidebarActive.value===false) {
            taxToEdit.value=null
          }

        })
        if(!store.hasModule(TAX_MODULE)) store.registerModule(TAX_MODULE, taxModule)

        onUnmounted(() => {
            if(store.hasModule(TAX_MODULE)) store.unregisterModule(TAX_MODULE)
        })

        return {
          isAddNewTaxSidebarActive,
          refTaxListTable,
          perPageOptions,
          isSortDirDesc,
          tableColumns,
          searchQuery,
          currentPage,
          refetchData,
          deletePopup,
          dataMeta,
          fetchTax,
          totalTax,
          perPage,
          ability,
          sortBy,
          fetchTaxToEdit,
          addTax
          }
    }
}
</script>

<style lang="scss">
@import '~@core/scss/vue/libs/vue-select.scss';
</style>